export default "__VITE_ASSET__DSup1xWY__"